import Cookies from 'js-cookie';
import { COOKIE_CONSENT_SETTINGS } from '../constants/cookies';

const SERVICE_NAME = 'Jopsy Tracking';

// one-time cleanup of the obsolete banner cookie (can be removed after ~1 year)
Cookies.remove(COOKIE_CONSENT_SETTINGS);

// Reads UC's stored state. ucData is internal to Usercentrics, not a documented API.
// If its format changes this returns false (tracking off), so check here first.
const readStoredConsent = (): boolean => {
  try {
    const raw = localStorage.getItem('ucData');
    if (!raw) return false;
    const services = JSON.parse(raw)?.consent?.services ?? {};
    return Object.values<any>(services).some(
      (s) => s?.name === SERVICE_NAME && s?.consent === true,
    );
  } catch {
    return false;
  }
};

let allowed = readStoredConsent();

// eslint-disable-next-line no-unused-vars
type Listener = (isAllowed: boolean) => void;
const listeners = new Set<Listener>();

window.addEventListener('UC_CONSENT', (e: any) => {
  const services = e.detail?.services ?? {};
  const s =
    services[SERVICE_NAME] ??
    Object.values<any>(services).find((x) => x?.name === SERVICE_NAME);
  allowed = !!s?.consent?.given;
  listeners.forEach((cb) => cb(allowed));
});

export const trackingAllowed = (): boolean => allowed;

// returns an unsubscribe function
export const onTrackingConsentChange = (cb: Listener): (() => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

export const openConsentSettings = () => {
  // eslint-disable-next-line no-underscore-dangle
  const uc = (window as any).UC_UI ?? (window as any).__ucCmp;
  uc?.showSecondLayer?.();
};
